// Shared chrome for authenticated admin pages: a top AppBar with the program
// name, primary nav links, and a logout button, plus a content container that
// renders the active route via <Outlet />.
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Outlet, NavLink } from 'react-router';
import {
  AppBar, Toolbar, Typography, Button, Box, Container, Stack,
} from '@mui/material';
import { logoutAdmin, selectAdminUser } from '../../store/admin-auth-slice.js';
import { selectSettings } from '../../store/settings-slice.js';
import ThemeModeToggle from '../ThemeModeToggle.jsx';

const NAV_LINKS = [
  { to: '/admin', label: 'Dashboard', end: true },
  { to: '/admin/catalog', label: 'Catalog' },
  { to: '/admin/pricing', label: 'Pricing' },
  { to: '/admin/blacklist', label: 'Blacklist' },
  { to: '/admin/inquiries', label: 'Inquiries' },
  { to: '/admin/participation', label: 'Participation' },
  { to: '/admin/branding', label: 'Branding' },
  { to: '/admin/email', label: 'Email' },
  { to: '/admin/settings', label: 'Settings' },
];

const AdminLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectAdminUser);
  const settings = useSelector(selectSettings);

  const handleLogout = async () => {
    await dispatch(logoutAdmin());
    navigate('/admin/login');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static" color="default" elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Toolbar sx={{ gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="h6" component="p" sx={{ fontWeight: 700, mr: 2 }}>
            {settings.program_name}
            {' '}
            Admin
          </Typography>
          <Stack direction="row" spacing={1} component="nav" aria-label="Admin sections" sx={{ flexGrow: 1 }}>
            {NAV_LINKS.map((link) => (
              <Button
                key={link.to}
                component={NavLink}
                to={link.to}
                end={link.end}
                color="inherit"
                sx={{ '&.active': { color: 'primary.main', fontWeight: 700 } }}
              >
                {link.label}
              </Button>
            ))}
          </Stack>
          <ThemeModeToggle />
          <Typography variant="body2" color="text.secondary">
            {user?.username}
          </Typography>
          <Button onClick={handleLogout} variant="outlined" size="small">
            Sign out
          </Button>
        </Toolbar>
      </AppBar>

      <Container component="main" maxWidth="lg" sx={{ py: 4 }}>
        <Outlet />
      </Container>
    </Box>
  );
};

export default AdminLayout;
